import { Link } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Badge } from "@odingard/design-system";
import { EmptyState, ErrorState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../../lib/auth";
import { useAsync } from "../../lib/useAsync";
import { proposalApi } from "../../lib/api";
import { DemoModeBanner, LiveModeBadge } from "../../components/ProposalGrounded";

// Connected intelligence surfaces proposal-to-contract continuity, which is
// opportunity-scoped. This page lists opportunities and links into each one's
// handoff (freeze baseline → request contract draft → acceptance gate).
export function PaiConnected() {
  const { activeOrg } = useAuth();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(async () => proposalApi.opportunities(orgId), [orgId]);
  const opportunities = state.data?.data.opportunities ?? [];

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Connected Intelligence</h1>
          <p>Proposal to contract continuity and handoff, per opportunity.</p>
        </div>
        <LiveModeBadge demoMode={state.data?.demoMode ?? false} />
      </div>

      <DemoModeBanner show={state.data?.demoMode ?? false} />
      {state.loading && <LoadingState label="Loading opportunities…" />}
      {state.error && <ErrorState description={state.error.message} onRetry={state.reload} />}
      {!state.loading && opportunities.length === 0 && (
        <EmptyState title="No opportunities" description="Create an opportunity to enable proposal to contract handoff." />
      )}
      {opportunities.length > 0 && (
        <div className="ods-stack">
          {opportunities.map((o) => (
            <Card key={o.id}>
              <CardHeader
                title={o.title}
                action={
                  <Link to={`/studio/proposal-ai/opportunities/${o.id}`}>
                    <Button size="sm">Open handoff</Button>
                  </Link>
                }
              />
              <CardBody>
                <div className="ods-row" style={{ gap: "var(--ods-space-2)" }}>
                  <Badge tone="info">{o.stage}</Badge>
                  {o.agency && <Badge tone="neutral">{o.agency}</Badge>}
                </div>
              </CardBody>
            </Card>
          ))}
        </div>
      )}
    </>
  );
}
